import { Group, Input, Stack, Text, ThemeIcon } from "@mantine/core";
import { Dropzone as MantineDropzone, MIME_TYPES } from "@mantine/dropzone";
import { IconPhoto, IconUpload, IconX } from "@tabler/icons-react";

type DropZoneProps = {
  mimeTypes?: string[];
  onDrop: (files: File[]) => void;
  onReject?: () => void;
  disabled?: boolean;
  error?: string[] | undefined;
  multiple?: boolean;
};

export function DropZone({ mimeTypes = [MIME_TYPES.csv, MIME_TYPES.xls], error, ...props }: DropZoneProps) {
  return (
    <Stack>
      <MantineDropzone accept={mimeTypes} maxSize={5 * 1024 ** 2} {...props}>
        <Group justify="center" gap="xl" mih={220} style={{ pointerEvents: "none" }}>
          <MantineDropzone.Accept>
            <ThemeIcon color="zli-blue" size="xl" variant="transparent">
              <IconUpload stroke={1.5} size={52} />
            </ThemeIcon>
          </MantineDropzone.Accept>
          <MantineDropzone.Reject>
            <ThemeIcon color="red" size="xl" variant="transparent">
              <IconX stroke={1.5} size={52} />
            </ThemeIcon>
          </MantineDropzone.Reject>
          <MantineDropzone.Idle>
            <ThemeIcon c="dimmed" size="xl" variant="transparent">
              <IconPhoto size={52} stroke={1.5} />
            </ThemeIcon>
          </MantineDropzone.Idle>

          <div>
            <Text size="xl" inline>
              Ziehe deine Datei hierher oder klicke, um eine Datei auszuwählen.
            </Text>
            <Text size="sm" c="dimmed" inline mt={7}>
              Die Datei sollte nicht grösser als 5mb sein.
            </Text>
          </div>
        </Group>
      </MantineDropzone>
      {error && <Input.Error>{error}</Input.Error>}
    </Stack>
  );
}
